import { render, staticRenderFns } from "./AddAkmam.vue?vue&type=template&id=6ae7724e&scoped=true&"
import script from "./AddAkmam.vue?vue&type=script&lang=js&"
export * from "./AddAkmam.vue?vue&type=script&lang=js&"
import style0 from "./AddAkmam.vue?vue&type=style&index=0&id=6ae7724e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7724e",
  null
  
)

export default component.exports